import { render, staticRenderFns } from "./PNLByDayBarChart.vue?vue&type=template&id=39a2ee7c&scoped=true"
import script from "./PNLByDayBarChart.vue?vue&type=script&lang=ts"
export * from "./PNLByDayBarChart.vue?vue&type=script&lang=ts"
import style0 from "./PNLByDayBarChart.vue?vue&type=style&index=0&id=39a2ee7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a2ee7c",
  null
  
)

export default component.exports